export default __webpack_public_path__ + "static/media/timeline.f3aedffa.svg";